import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlanEditReason } from './plan-edit-reason-dialog.component';
import { FormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { DialogContainerModule } from 'src/app/shared/dialog-container/dialog-container.module';

@NgModule({
  declarations: [
    PlanEditReason
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    DialogContainerModule,
  ]
})
export class PlanEditReasonDialogModule { }
